import React, { useEffect, useState, useContext } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";

import "swiper/css";
import "swiper/css/free-mode";

import "./CategoryTabs.css";
import All from "./all/All";
import Fire from "./fire/Fire";
import { useLocation, useNavigate } from "react-router-dom";
import { getEffects } from "../../../utils/apis/effects/Effects";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";
import EffectInfo from "./fire/effect_info/EffectInfo";

const categories = [
  { id: 1, name: "All", img: "/assets/images/gallary/img1.png" },
  { id: 2, name: "Fire", img: "/assets/images/gallary/img2.png" },
  { id: 3, name: "Cold / Ice", img: "/assets/images/gallary/img3.png" },
  { id: 4, name: "Electric", img: "/assets/images/gallary/img4.png" },
  { id: 5, name: "Air / Wind", img: "/assets/images/gallary/img5.png" },
  { id: 6, name: "Water", img: "/assets/images/gallary/img5.png" },
  { id: 7, name: "Dark / Shadow", img: "/assets/images/gallary/img5.png" },
];

const tabComponents = {
  1: <All />,
  2: <Fire />,
  3: <Fire />,
  4: <Fire />,
  5: <Fire />,
  6: <Fire />,
  7: <Fire />,
};

const CategoryTabs = () => {
  const location = useLocation();
  const [active, setActive] = useState("all");

  useEffect(() => {
    if (location.state?.activeTab) {
      setActive(location.state.activeTab);
    }
  }, [location.state]);

  const [effectcategory, setEffect] = useState([]);

  const navigate = useNavigate();

  const { IMG_URL } = useContext(Context);

  const getEffect = async () => {
    const res = await getEffects();
    if (res?.success) {
      setEffect(res.data);
    }
  };
  useEffect(() => {
    getEffect();
  }, []);

  // const handleServiceClick = (id) => {
  //   navigate(`/effect/${id}`);
  // };

  return (
    <div className="category-tabs-wrapper">
      <h3 className="Category-title">Category of Effects</h3>

      <div className="wrapper">
        <div className=" container">
          <div className="desktop-tabs">
            <div className="w-100">
              <Swiper
                slidesPerView="8"
                spaceBetween={15}
                freeMode={true}
                modules={[FreeMode]}
                breakpoints={{
                  320: {
                    slidesPerView: 4,
                    spaceBetween: 10,
                  },
                  480: {
                    slidesPerView: 5,
                    spaceBetween: 10,
                  },
                  640: {
                    slidesPerView: 5,
                    spaceBetween: 12,
                  },
                  768: {
                    slidesPerView: 6,
                    spaceBetween: 12,
                  },
                  1024: {
                    slidesPerView: 7,
                    spaceBetween: 15,
                  },
                  1280: {
                    slidesPerView: 9,
                    spaceBetween: 15,
                  },
                }}
              >
                {/*  ALL TAB (STATIC) */}
                <SwiperSlide
                  key="all"
                  className={`tab-slide ${active === "all" ? "active" : ""}`}
                >
                  <div className="tab-item" onClick={() => setActive("all")}>
                    <div className="img-wrap">
                      <img src="/assets/images/gallary/img1.png" alt="All" />
                    </div>
                    <span>All</span>
                  </div>
                </SwiperSlide>

                {effectcategory.map((cat) => (
                  <SwiperSlide
                    key={cat.id}
                    className={`tab-slide ${
                      active === cat?.id ? "active" : ""
                    }`}
                  >
                    <div className="tab-item" onClick={() => setActive(cat.id)}>
                      <div className="img-wrap">
                        <img src={IDS?.IMG_URL + cat.image} alt={cat?.name} />
                      </div>
                      <span>{cat?.name}</span>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="tab-content">{tabComponents[active]}</div> */}

      {/* <div className="tab-content">
        {active === "all" ? <All /> : <Fire categoryId={active} />}
      </div> */}

      <div className="tab-content">
        {/* {active === "all" ? <All /> : <EffectInfo effectId={active} />} */}

        {active === "all" ? (
          <All setActive={setActive} />
        ) : (
          <EffectInfo effectId={active} />
        )}
      </div>
    </div>
  );
};

export default CategoryTabs;
